import _ from 'lodash';
window._ = _;
import Search from "./scripts/Search";
// import "jquery-mask-plugin/src/jquery.mask.js"
import NavigateScripts from "./scripts/Navigate";
import ProductScripts from "./scripts/Product";
// import "@material-tailwind/html/scripts/collapse.js"
// import "pagedone/src/js/pagedone.js"
import CartScripts from "./scripts/Cart";
import CategoryScripts from "./scripts/Category";
import HomeScripts from "./scripts/Home";
import QuizScripts from "./scripts/Quiz";
import GaiaSlides from "./scripts/Swiper";
import ComparativoSlides from "./scripts/Comparativo";
import ytScriptsInstance from "./scripts/YTPlayers";
import GaiaLoveScripts from "./scripts/GaiaLove";

// Initialization
window.HSStaticMethods.autoInit();
const search = new Search();
const gaiaSlides = new GaiaSlides();
const navigateScripts = new NavigateScripts();
const productScripts = new ProductScripts();
const cartScripts = new CartScripts();
const categoryScripts = new CategoryScripts();
const homeScripts = new HomeScripts();
const quizScripts = new QuizScripts();
const comparativoScripts = new ComparativoSlides();
const gaiaLoveScripts = new GaiaLoveScripts();

document.addEventListener("DOMContentLoaded", function () {
  window.HSStaticMethods.autoInit();

  // Lista de desejos
  var btnListaDesejos = document.querySelectorAll(".btn_lista_desejos");
  btnListaDesejos.forEach(function (btn) {
    btn.addEventListener("click", function () {
      window.location = "/wish-list";
    });
  });

  // Troca de idioma
  const languageSelect = document.getElementById("hs-select-language");
  languageSelect.addEventListener("change", function () {
    this.closest('#container-languages').classList.add('loading');
    const url = languageSelect.querySelector("option:checked").dataset.url;
    window.location.href = url;
  });
  const languageSelectMobile = document.getElementById("hs-select-language-mobile");
  languageSelectMobile.addEventListener("change", function () {
    this.closest('#container-languages').classList.add('loading');
    const url = languageSelectMobile.querySelector("option:checked").dataset.url;
    window.location.href = url;
  });

  // Troca de região
  const regionSelect = document.getElementById("hs-select-region");
  if (regionSelect) {
    regionSelect.addEventListener("change", function () {
      const selectedOption = regionSelect.querySelector("option:checked");
      const url = selectedOption.dataset.url;
      
      if (url) {
        this.closest('.region_container').classList.add('loading');
        window.location.href = url;
      }
    });
  }
  const regionSelectMobile = document.getElementById("hs-select-region-mobile");
  if (regionSelectMobile) {
    regionSelectMobile.addEventListener("change", function () {
      const selectedOption = regionSelectMobile.querySelector("option:checked");
      const url = selectedOption.dataset.url;
      
      if (url) {
        this.closest('.region_container').classList.add('loading');
        window.location.href = url;
      }
    });
  }

  // Validar campos formulário de contato
  let form = document.querySelector('.wpcf7-form');
  if (form) {
    form.addEventListener('input', function (event) {
      let field = event.target;
      if (field.classList.contains('wpcf7-validates-as-required')) {
        if (field.type != 'radio') {
          if (field.value != '' && field.value != null) {
            field.classList.remove('invalid-field');
          } else {
            field.classList.add('invalid-field');
          }
        }

        if (field.type == 'radio') {
          if (field.checked) {
            field.classList.remove('invalid-field');
          } else {
            field.classList.add('invalid-field');
          }
        }
      }
      if (field.name == 'accept-terms') {
        if (field.checked) {
          field.classList.remove('invalid-field');
        } else {
          field.classList.add('invalid-field');
        }
      }
    });

    const buttonSubmit = form.querySelector('input[type="submit"]');
    if (buttonSubmit) {
      buttonSubmit.addEventListener('click', function (event) {
        let fields = form.querySelectorAll('.wpcf7-validates-as-required');
        fields.forEach(function (field) {
          if (field.type != 'radio') {
            if (field.value != '' && field.value != null) {
              field.classList.remove('invalid-field');
            } else {
              field.classList.add('invalid-field');
            }
          }
          if (field.type == 'radio') {
            if (field.checked) {
              field.classList.remove('invalid-field');
            } else {
              field.classList.add('invalid-field');
            }
          }
        });
        let acceptTerms = form.querySelector('input[name="accept-terms"]');
        if (acceptTerms.checked) {
          acceptTerms.classList.remove('invalid-field');
        } else {
          acceptTerms.classList.add('invalid-field');
        }
      });
    }
  }
});

// Função para fechar o Toastify
window.tostifyCustomClose = (el) => {
  const parent = el.closest('.toastify');
  const close = parent.querySelector('.toast-close');

  close.click();
}

// Função global para notificações usando Toastify
window.notify = (message, options = {}) => {
  // Definir opções padrão
  const defaults = {
      type: 'info',         // success, error, warning, info
      position: 'top-right', // top-right, top-center, top-left, bottom-right, bottom-center, bottom-left
      duration: 3000,       // duração em ms
      close: true,          // mostrar botão de fechar
      classes: ''           // classes adicionais
  };
  
  // Mesclar opções padrão com as fornecidas
  const config = { ...defaults, ...options };
  
  // Definir classe de cor com base no tipo
  let typeClass = '';
  let bgColor = '';
  let borderColor = '';
  
  switch (config.type) {
      case 'success':
          typeClass = 'success text-white dark:text-white m-0';
          bgColor = 'bg-green-500 bg-none';
          borderColor = 'border-green-400';
          break;
      case 'error':
          typeClass = 'error text-white dark:text-white m-0';
          bgColor = 'bg-red-500 bg-none';
          borderColor = 'border-red-400';
          break;
      case 'warning':
          typeClass = 'warning text-white dark:text-white m-0';
          bgColor = 'bg-yellow-500 bg-none';
          borderColor = 'border-yellow-400';
          break;
      default: // info
          typeClass = 'info text-white dark:text-white m-0';
          bgColor = 'bg-secondary bg-none';
          borderColor = 'border-secondary';
          break;
  }
  
  // Definir classe de posição
  let positionClass = '';
  switch (config.position) {
      case 'top-left':
          positionClass = 'left-5 top-5';
          break;
      case 'top-center':
          positionClass = '';
          break;
      case 'bottom-right':
          positionClass = 'right-5 bottom-5';
          break;
      case 'bottom-center':
          positionClass = '';
          break;
      case 'bottom-left':
          positionClass = 'left-5 bottom-5';
          break;
      default: // top-right
          positionClass = 'right-5 top-5';
          break;
  }
  
  // Criar conteúdo HTML para a notificação
  const toastAlert = (message, className) => { 
      return `
      <div class="flex p-4">
          <p class="text-sm ${className}">${message}</p>
          <div class="ms-auto">
              <button onclick="tostifyCustomClose(this)" type="button" class="inline-flex shrink-0 justify-center items-center size-5 rounded-lg text-white opacity-50 hover:opacity-100 focus:outline-hidden focus:opacity-100 dark:text-white" aria-label="Close">
                  <span class="sr-only">Close</span>
                  <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
              </button>
          </div>
      </div>
      `;
  };
  
  // Configurar e mostrar o toast
  Toastify({
      text: toastAlert(message, typeClass),
      className: `hs-toastify-on:opacity-100 opacity-0 fixed ${positionClass} z-100 transition-all duration-300 w-full max-w-80 ${bgColor} text-sm text-white border ${borderColor} rounded-xl shadow-lg [&>.toast-close]:hidden dark:${bgColor} dark:${borderColor} dark:text-white ${config.classes}`,
      duration: config.duration,
      close: config.close,
      escapeMarkup: false,
      gravity: config.position.startsWith('top') ? 'top' : 'bottom',
      position: config.position.endsWith('left') ? 'left' : config.position.endsWith('center') ? 'center' : 'right'
  }).showToast();
};

// Language functions
fetch('/wp-content/themes/gaia-pole/languages/gaia-js-translations.json?v=13')
  .then(response => response.json())
  .then(data => {
    window.gaiaTranslations = data;
  });
window.t = function(key, language = null, params = null) {
  if (!language) {
    language = document.documentElement.lang.replace('-', '_');
  }

  const keys = key.split('.');
  let value = window.gaiaTranslations[language];

  for (const k of keys) {
      value = value?.[k];
  }


  // Verifica se há parâmetros para substituir
  if (params) {
    for (const param in params) {
      value = value.replace(`{${param}}`, params[param]);
    }
  }

  return value || key;
};

// Currency functions
window.gaia_currency = {
  format: function(value) {
    if (gaiaCustomData.current_currency == 'EUR') {
      return value.toLocaleString('en-US', { 
        style: 'decimal', 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2
      }) + ' €';
    } else {
      return '$ ' + value.toLocaleString('en-US', { 
        style: 'decimal', 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2
      });
    }
  }
};